import {
  AboutPage,
  CareerDetailsPage,
  CareersPage,
  ChangePassword,
  ContactPage,
  Customer,
  CustomerDetails,
  CustomerNew,
  ForgotPassword,
  LandingPage,
  Login,
  MagicLogin,
  MerchPage,
  OrderPage,
  OrderSuccessPage,
  OrdersManagementPage,
  ProductDetailPage,
  ProductsManagementPage,
  ProjectDetailsPage,
  ProjectsPage,
  QuotePage,
  ServicesPage,
  SettingsPage,
  TalentPoolPage,
  UsersPage
} from '@components/pages';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PrivateTemplate, PublicTemplate } from './@components/templates';

function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicTemplate />}>
        <Route index element={<LandingPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:projectId" element={<ProjectDetailsPage />} />
        <Route path="careers" element={<CareersPage />} />
        <Route path="talent-pool" element={<TalentPoolPage />} />
        <Route path="careers/:positionId" element={<CareerDetailsPage />} />
        <Route path="merch" element={<MerchPage />} />
        <Route path="merch/:id" element={<ProductDetailPage />} />
        <Route path="orders/:orderId" element={<OrderPage />} />
        <Route path="order-success" element={<OrderSuccessPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="quote" element={<QuotePage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="users/:userId" element={<UsersPage />} />
      </Route>
      <Route path="/app" element={<PrivateTemplate />}>
        <Route index element={<Navigate to="/app/clientes" replace />} />
        <Route path="clientes/">
          <Route index element={<Customer />} />
          <Route path="novo" element={<CustomerNew />} />
          <Route path=":customerId" element={<CustomerDetails />} />
        </Route>
        <Route path="produtos" element={<ProductsManagementPage />} />
        <Route path="pedidos" element={<OrdersManagementPage />} />
        <Route path="configuracoes" element={<SettingsPage />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/magic-login" element={<MagicLogin />} />
      <Route path="/reset-password" element={<ChangePassword />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
    </Routes>
  );
}

export default App;
